<template src="./paladin-notes.html"></template>

<script>
// import _ from 'lodash'
import {
  PersonApi,
  GroupApi,
  ApiAddNoteRequest,
  ApiAddNotePersonRequest,
  ApiEntityRequest,
  ApiEntityPagedRequest,
  Limit,
} from '@chirhos/chirhos-api'
import { ChiRhos } from '@paladin/core'

// import moment from 'moment'
import PaladinNote from './paladin-note.vue'
// import PaladinPersonLookup from '../../../library/components/personlookup/paladin-person-lookup'
// import PaladinLimit from '../../../library/components/limit/paladin-limit'

import { PaladinLimit, PaladinPersonLookup } from '@paladin/core-components'

let ChiRhosApi = new ChiRhos().api()

var personApi = new PersonApi(ChiRhosApi)
var groupApi = new GroupApi(ChiRhosApi)

export default {
  name: 'PaladinNotes',
  components: {
    PaladinNote,
    PaladinPersonLookup,
    PaladinLimit,
  },
  props: {
    allRoles: {
      type: Array,
      default: null
    },
    placeholderText: {
      type: String,
      default: 'Add a new note...',
    },
    entity: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      default: 'group',
      validator: (value) => {
        let acceptedValues = ['group', 'person', 'event']
        return acceptedValues.indexOf(value) !== -1
      },
    },
  },
  data() {
    return {
      isLoading: true,
      notes: [],
      peopleEntityIdList: [],
      peopleList: [],
      form: {
        person: '',
        newNoteText: '',
        limit: {},
      },
    }
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.$nextTick(function() {
      // if (this.type !== 'person')
      this.loadNotes()
    })
  },
  created: function() {
  },
  methods: {
    async loadNotes() {
      let _pointInTime = new Date()

      let _groupListNotesPromise

      if (this.type === 'group') {
        _groupListNotesPromise = groupApi.ListNotes({
          request: new ApiEntityPagedRequest(this.entity.entityId, 1, 100, false, null, null, _pointInTime),
        })
      } else if (this.type === 'event') {
        // TODO: Add get event notes logic
      } else if (this.type === 'person') {
        _groupListNotesPromise = groupApi.ListPersonNotes({
          request: new ApiEntityPagedRequest(this.entity.entityId, 1, 100, false, null, null, _pointInTime),
        })
      }

      let noteDataResponse = await Promise.all([
        _groupListNotesPromise,
      ]).then(function(values) {
        return values
      })

      this.notes = noteDataResponse[0].data
      // console.log(this.notes)
    },
    cachePerson(entityId) {
      if (this.peopleEntityIdList && !this.peopleEntityIdList.includes(entityId)) {
        this.peopleEntityIdList.push(entityId)
        // console.log('Get person: ', entityId)
        personApi.Get({ request: new ApiEntityRequest(entityId) }).then((result) => {
          this.peopleList.push(result.data)
        })
      }
    },
    personSelected(value) {
      this.form.person = value
      // this.loadNotes()
    },
    setLimit(value)
    {
      this.form.limit = value
    },
    submitNewNote(evt) {
      evt.preventDefault()

      if (this.type === 'group') {
        let _groupRequest = new ApiAddNoteRequest()
        if (this.isOpen === null) _groupRequest.limit = new Limit()
        else _groupRequest.limit = this.form.limit
        _groupRequest.text = this.form.newNoteText
        _groupRequest.entityId = this.entity.entityId
        groupApi.SaveNote({ request: _groupRequest }).then((data) => {
          // console.log(data)
          this.loadNotes()
          this.form.newNoteText = ''
        })
      } else if (this.type === 'event') {
        // TODO: event save note logic
        // let _eventRequest = new ApiAddNoteRequest()
      } else if (this.type === 'person') {
        let _personRequest = new ApiAddNotePersonRequest()
        if (this.isOpen === null) _personRequest.limit = new Limit()
        else _personRequest.limit = this.form.limit
        _personRequest.text = this.form.newNoteText
        _personRequest.entityId = this.form.person.entityId
        _personRequest.groupEntityId = this.entity.entityId
        groupApi.SavePersonNote({ request: _personRequest }).then((data) => {
          // console.log(data)
          this.loadNotes()
          this.form.newNoteText = ''
        })
      } else {
        this.$toast('A valid type has not been set for this component', 'error')
      }
    },
  },
}
</script>

<style lang="scss">
.form-inputs {
  display: inline-block !important;
  margin-right: 5px;
  margin-left: 5px;
  vertical-align: bottom;
  width: inherit !important;

  &.no-margin {
    margin: 0;
    padding-right: 0;
  }

  .multiselect {
    display: inline-block !important;
    width: inherit !important;
  }
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
